import { Component, inject } from "@angular/core"
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent } from "@angular/material/dialog"
import { MatIcon } from "@angular/material/icon"
import { ExpandRowComponent } from "../expand-row/expand-row.component"

export interface ExpandDialogData {
    data: any
    emptyMessage: string
}

@Component({
    selector: "valben-expand-dialog",
    standalone: true,
    imports: [MatDialogContent, MatDialogClose, MatIcon, ExpandRowComponent],
    template: `
        <button class="valben-dialog-close" mat-dialog-close aria-label="Zatvori">
            <mat-icon>close</mat-icon>
        </button>
        <mat-dialog-content>
            @if (data.data && data.data.length > 0) {
                <div class="flex">
                    <valben-expand-row class="grow" [value]="data.data"></valben-expand-row>
                </div>
            }
            @if (!data.data || data.data.length === 0) {
                <p>{{ data.emptyMessage }}</p>
            }
        </mat-dialog-content>
    `,
})
export class ExpandDialogComponent {
    readonly data = inject<ExpandDialogData>(MAT_DIALOG_DATA)
}
